import styled from 'styled-components';
import { colors, layout, media } from '@prisjakt/ui-base';

import Clickable from '@prisjakt/ui-clickable';
import { TextButton } from '@prisjakt/ui/button/variants';
import ArrowUpIcon from 'mdi-react/ArrowUpIcon';

export const IMAGE_SIZE = 48;
export const POSITION_SIZE = 25;
const spacing125 = layout.measurements.spacing125;

type ProductsArrowProps = {
  down?: string;
};
export const ProductsArrow = styled(ArrowUpIcon)<ProductsArrowProps>`
  width: ${layout.measurements.fontSizeLarge};
  ${p =>
    p.down === 'true' &&
    `
    transform: rotate(180deg)
  `}
`;

export const ProductRow = styled.div`
  display: grid;
  grid-template-columns: ${IMAGE_SIZE}px 1fr;
  column-gap: ${layout.measurements.spacing100};
  align-items: center;
`;

export const ProductToplistWrapper = styled.div`
  margin: ${layout.measurements.spacing200} 0;
  padding: ${spacing125} ${spacing125} ${layout.measurements.spacing100}
    ${spacing125};
  border: 1px solid ${colors.lightTheme.base200};
  border-radius: ${layout.measurements.spacing125};

  ${media.largeUp`
    margin-top: ${layout.measurements.spacing250};
    margin-left: ${layout.measurements.spacing150};
  `};

  a {
    display: block;
    margin-bottom: ${layout.measurements.spacing025};
    position: relative;
  }
`;

export const ProductToplist = styled.div`
  display: grid;
  grid-auto-flow: row;
  row-gap: ${layout.measurements.spacing050};

  > * {
    margin: 0;
  }
`;

export const ShowMoreButton = styled(TextButton)`
  width: 100%;

  span {
    margin: 0 ${layout.measurements.spacing025};
    flex: initial;
  }
`;

export const ProductName = styled.div`
  &:hover {
    color: ${p => p.theme.text.linkExternal};
  }
`;

export const ListPosition = styled.p`
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  background-color: ${colors.lightTheme.maybeBlue500};
  color: white;
  width: ${POSITION_SIZE}px;
  height: ${POSITION_SIZE}px;
  border-radius: 0.125rem;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  line-height: 0;
`;

export const Link = styled(Clickable)`
  margin-bottom: ${layout.measurements.spacing050};
  color: ${p => p.theme.text.callToAction};
  cursor: pointer;
  outline: none;

  &:hover,
  &:focus {
    color: ${p => p.theme.text.callToActionHover};
    text-decoration: underline;
  }
`;
